module.exports = __webpack_public_path__ + "c12587612331420a4cb5b3e109729dcd.svg";